import React from 'react';
import './Footer.css'

function Footer(){

    return(
        <footer>
            <div className="conteneur_footer">
                <span>Bucket-list Online<br/>&copy; BAY TAMSAMANI Houdayfa</span>
            </div>
        </footer>
    )

}

export default Footer;